import { Component, Input, OnInit } from "@angular/core";

@Component({
  moduleId: module.id.toString(),
  selector: "my-actions",
  template: require('./actions.component.html')
})
export class ActionsComponent implements OnInit {
  devPortalUrl: string = process.env.AppSettings.devPortalUrl;
  constructor() {}

  @Input()
  links: string[] = [];
  @Input()
  isSSO: boolean = false;
  @Input()
  isPartnerUser: boolean = false;
  @Input()
  hasSsoAndPaycorIdentity: boolean = false;
  @Input()
  isMergeLinkVisible: boolean = false;
  @Input()
  showNewMergeLink: boolean = false;
  @Input()
  showNewToDLink: boolean = false;
  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/security/actions.component.ts